import React from 'react';

import { createComponent, Layout, Header, Label, enums, Image } from 'console-kit';
import authStatics from '../common/static';

const _imgSize = {
  height: '100',
  width:  '215',
};

const UnsupportedBrowser = createComponent({
  displayName: 'UnsupportedBrowser',
  handlers:    {
    handleBrowserClick: p => hrefPath => {
      window.location.href = hrefPath;
    },
  },
  
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES_WIDE}>
        <Layout isFluidHeight columnStyles={{ textAlign: enums.textAlignments.CENTER }}>
          <Layout.Row>
            <Layout.Column>
              <Header
                text="Sorry we do not support this browser or browser version."
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X8}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column>
              <Label
                text="Please update your browser to a more recent version to use Marigold Grow. This application relies on modern browser technologies to deliver the best experience. You can update your browser version by clicking on the relevant browser icon below."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X5}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column>
              <Image
                src={`${App.globalContext.assetURL}c/img/icons/browser/Chrome_logo.svg`}
                size={_imgSize}
                onClick={() => props.handleBrowserClick('https://www.google.com/chrome/browser/desktop/index.html')}
              />
            </Layout.Column>

            <Layout.Column>
              <Image
                src={`${App.globalContext.assetURL}c/img/icons/browser/Firefox_logo.svg`}
                size={_imgSize}
                onClick={() => props.handleBrowserClick('https://www.mozilla.org/en-US/firefox/products/')}
              />
            </Layout.Column>

            <Layout.Column>
              <Image
                src={`${App.globalContext.assetURL}c/img/icons/browser/Safari_logo.svg`}
                size={_imgSize}
                onClick={() => props.handleBrowserClick('https://support.apple.com/downloads/safari')}
              />
            </Layout.Column>

            <Layout.Column>
              <Image
                src={`${App.globalContext.assetURL}c/img/icons/browser/MicrosoftEdge_logo.svg`}
                size={_imgSize}
                onClick={() => props.handleBrowserClick('https://www.microsoft.com/en-us/windows/microsoft-edge')}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column>
              <Label
                text="If you are not allowed to update your browser version, please contact your IT department to update it on your behalf."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X5}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>
        </Layout>
      </div>
    );
  },
});

export default UnsupportedBrowser;
